<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    include /@ibkr/lib.common/src/icon/arrow
    
    .ib-col(class="flex")
        .ib-row
            .ib-col(class="")
                h1(class="insety-32") {{ $t('ib_regulatory_information_header') }}


        .ib-row
            .ib-col
                p(class="fs7 insety-8") {{ $t('ib_regulatory_information_para_1') }} 
                p(class="fs7 insety-8") {{ $t('ib_regulatory_information_para_2') }} 
                p(class="fs7 insety-8") {{ $t('ib_regulatory_information_para_3') }} 
                span(class="insety-32") 
                        ib-button.insety-16(tone="sell" appearance="link" @click="getUrlIBAnnualFinStatement") {{ $t('ib_financial_statements') }}
                            +icon-arrow-right2
        
        hr(class="before-24")
        .ib-row.grow.insety-16
            .ib-col
                p(class="fs3 insety-16") {{ $t('fin_info') }}

       
        div(class="panel",:class="{'active':this.isCapital === true}"  @click ="expand(1)")
            span(v-show="this.isCapital == false") 
                +icon-arrow-forward_filled
            span(v-show="this.isCapital == true")
                +icon-arrow-expand_arrow_filled
            span(class="insetx-8") {{ $t('capital') }}
        Capital(v-show="this.isCapital",:netCapitalList= "netCapitalList")

        div(class="panel",:class="{'active':this.isCustomerMoneySegregationComputations === true}" @click ="expand(2)")
            span(v-show="this.isCustomerMoneySegregationComputations == false") 
                +icon-arrow-forward_filled
            span(v-show="this.isCustomerMoneySegregationComputations == true") 
                +icon-arrow-expand_arrow_filled
            span(class="insetx-8") {{ $t('cust_money_seg') }}
        CustomerMoneySegregationComputation(v-show="this.isCustomerMoneySegregationComputations",
        :CommodityDomesticSegregationList= "CommodityDomesticSegregationList",
        :CommodityForeignSegregationList= "CommodityForeignSegregationList",
        :CommoditySwapSegregationList= "CommoditySwapSegregationList",
        :Securities15c3SegregationList= "Securities15c3SegregationList")     
        
        div(class="panel",:class="{'active':this.isFutureCustomerConcentration === true}" @click ="expand(3)")
            span(v-show="this.isFutureCustomerConcentration == false") 
                +icon-arrow-forward_filled
            span(v-show="this.isFutureCustomerConcentration == true")
                +icon-arrow-expand_arrow_filled 
            span(class="insetx-8") {{ $t('fut_cust_concent') }}
        FutureCustomerConcentration(v-show="this.isFutureCustomerConcentration",
        :Cust50PercentNetLiqList= "Cust50PercentNetLiqList")
        
        div(class="panel",:class="{'active':this.isFutureMarginRequirements === true}" @click ="expand(4)")
            span(v-show="this.isFutureMarginRequirements == false") 
                +icon-arrow-forward_filled
            span(v-show="this.isFutureMarginRequirements == true")
                +icon-arrow-expand_arrow_filled
            span(class="insetx-8") {{ $t('fut_mar_req') }}
        FuturesMarginRequirements(v-show="this.isFutureMarginRequirements",
        :netCapitalList= "netCapitalList")

        hr(class="before-32") 
        .ib-row.grow.insety-16
            .ib-col
                p(class="fs3 insety-16")  {{ $t('reg_disclosures_header') }}
                span(class="")
                    p(class="fs7 insety-8") {{ $t('reg_disclosures_para_1') }}
                span(class="insety-16") 
                    a(class="fs7 fg-sell", target="_blank", href="https://gdcdyn.interactivebrokers.com/Universal/servlet/Registration_v2.formSampleView?formdb=3355") {{ $t('reg_disclosures_link') }}
                        +icon-arrow-right2
                
        hr(class="before-32")
        .ib-row.grow.insety-16
            .ib-col                
                p(class="fs3 insety-16") {{ $t('add_info_header') }}
                span(class="")
                    p(class="fs7") {{ $t('add_info_para_1_1') }} <a href="http://www.nfa.futures.org/basicnet/" target="_blank" class="fg-sell">{{ $t('add_info_nfa_link') }}</a> {{ $t('add_info_para_1_2') }}
                span(class="")
                    p(class="bold fs7 insety-8") {{ $t('add_info_para_2') }}  <a href="http://www.cftc.gov/MarketReports/financialfcmdata/index.htm" target="_blank" class="fg-sell">{{ $t('here') }}</a>.        
       
                    
            
</template>

<script>
    import api from '../api/'
    import Capital from '../components/Capital.vue'
    import CustomerMoneySegregationComputation from '../components/CustomerMoneySegregationComputation.vue'
    import FutureCustomerConcentration from '../components/FutureCustomerConcentration.vue'
    import FuturesMarginRequirements from '../components/FuturesMarginRequirements.vue'

    export default {
        name: 'RegulatoryInformation',

        components: {
            Capital,
            CustomerMoneySegregationComputation,
            FutureCustomerConcentration,
            FuturesMarginRequirements
        },

        data() {
            return {
                netCapitalList: [],
                Cust50PercentNetLiqList: [],
                CommodityDomesticSegregationList: [],
                CommodityForeignSegregationList: [],
                CommoditySwapSegregationList: [],
                Securities15c3SegregationList: [],
                isCapital:false, 
                isCustomerMoneySegregationComputations:false, 
                isFutureCustomerConcentration:false,
                isFutureMarginRequirements:false,               
           }
        },
        created() {

        },

        mounted() {

        },

        watch: {
           
        },
        computed: {

        },

        methods: {  

            getUrlIBAnnualFinStatement(){
                window.location.href = "/en/index.php?f=559";
            },

            expand(id){
                if(id == 1){
                    this.isCapital = !this.isCapital;
                }else if(id == 2){
                    this.isCustomerMoneySegregationComputations = !this.isCustomerMoneySegregationComputations;
                }else if(id == 3){
                    this.isFutureCustomerConcentration = !this.isFutureCustomerConcentration;
                }else if(id == 4){
                    this.isFutureMarginRequirements = !this.isFutureMarginRequirements;
                }    
                this.getFinancialInformation(this.isCapital,
                this.isCustomerMoneySegregationComputations,
                this.isFutureCustomerConcentration,
                this.isFutureMarginRequirements);            
            },

            getFinancialInformation(isCapital,isCustomerMoneySegregationComputations,isFutureCustomerConcentration,isFutureMarginRequirements){
                api.getFinancialInformation(isCapital,isCustomerMoneySegregationComputations,isFutureCustomerConcentration,isFutureMarginRequirements)
                    .then(res => {
                        this.netCapitalList = res.netCapitalList;
                        this.Cust50PercentNetLiqList = res.Cust50PercentNetLiqList;
                        this.CommodityDomesticSegregationList = res.CommodityDomesticSegregationList;
                        this.CommodityForeignSegregationList = res.CommodityForeignSegregationList;
                        this.CommoditySwapSegregationList = res.CommoditySwapSegregationList;
                        this.Securities15c3SegregationList = res.Securities15c3SegregationList;
                   }); 
            }

        }
}
</script>

<style lang="less">
.pointer {
    cursor: pointer;
}

.over-auto {
    overflow: auto;
}
.pre-wrap{
    white-space: pre-wrap;
}

.panel{
    color: #666666;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border-style: solid;
    border-width: 1px;
    border-color: #6666664f;
    text-align: left;
    outline: none;
    font-size:15px;
}

.active, .panel:hover{
    color: #000000;
    background-color: #DCDCDC;
}

.matdate {
    label {
        display: block;
    }
    //override
    ._field {
        border-radius: 3px;
    }
}
</style>
